export const dataBindingBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const dataBindingConventions = {
    getComponentName: ({ componentName }) => `$w.${componentName}`,
    patterns: [
        {
            part: 'dataBindingPanel',
            path: '{,*/}%ComponentName%/dataBinding/%ComponentName%.dataBindingPanel.ts',
        },
        {
            part: 'translations',
            path: '{,*/}%ComponentName%/dataBinding/%ComponentName%.translations.ts',
        },
    ],
};
//# sourceMappingURL=dataBinding.js.map